import { render, staticRenderFns } from "./listProjects.vue?vue&type=template&id=52eb518e"
import script from "./listProjects.vue?vue&type=script&lang=js"
export * from "./listProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports